import { type ComponentType } from 'react';
import { Context as ResponsiveContext } from 'react-responsive';

interface Breakpoints {
  desktop: number;
  desktopLg: number;
  desktopMd: number;
  phoneLg: number;
  phoneSm: number;
  tablet: number;
}

export const breakpoints: Breakpoints = {
  desktop: 1024,
  desktopLg: 1360,
  desktopMd: 1200,
  phoneLg: 600,
  phoneSm: 320,
  tablet: 768,
};

export interface Media {
  l: 1024;
  m: 981;
  s: 737;
  xl: 1281;
  xs: 376;
  xxl: 1361;
}

export const media: Media = {
  l: 1024,
  m: 981,
  s: 737,
  xl: 1281,
  xs: 376,
  xxl: 1361,
};

export const isDesktopQuery = {
  query: `(min-width: 1024px)`,
};

// query created to exclude ipad pro
export const isJustDesktopQuery = {
  query: `(min-width: 1025px)`,
};

export const isTabletQuery = {
  query: `(min-width: 768px) and (max-width: 1023px)`,
};

export const isTabletOrDesktopQuery = {
  query: `(min-width: 768px)`,
};

export const isTabletOrMobileQuery = {
  query: `(max-width: 1023px)`,
};

export const isMobileQuery = {
  query: `(max-width: ${breakpoints.phoneLg - 1}px)`,
};

export interface ResponsiveProps {
  deviceType?: string; // MOBILE, TABLET, DESKTOP
}

export function withMediaQueries<P>(Component: ComponentType<ResponsiveProps & P>): ComponentType<ResponsiveProps & P> {
  return (props: ResponsiveProps & P) => {
    // If on client, don't bother passing device width via context
    if (typeof window !== 'undefined') {
      return <Component {...props} />;
    }

    const { deviceType } = props;

    const deviceWidth =
      deviceType === 'MOBILE'
        ? breakpoints.phoneSm
        : deviceType === 'TABLET'
          ? breakpoints.tablet
          : breakpoints.desktop;

    return (
      <ResponsiveContext.Provider value={{ width: deviceWidth }}>
        <Component {...props} />
      </ResponsiveContext.Provider>
    );
  };
}
